import uuid from 'uuid/v1'
import { db } from '../../../config/firebaseconfig';

export default function resendInvite(record) {
  const { firstName, lastName, email, id} = record
  const time = Date.now()
  const resendId = uuid()
  const invite = {
    id: resendId,
    createdDate: time,
    expirationDate: time + 259200000,
    email,
    firstName,
    lastName,
    userId: id,
  }
  return db.collection('userInvites').doc(resendId).set(invite)
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/resendInvite.js